import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import {news, users, image_slider, training, general, timetables} from './modules/'
import createLogger from './../plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  getters,
  modules: {
    news,
    users,
    image_slider,
    training,
    general,
    timetables
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})
